module.exports = __webpack_public_path__ + "static/media/01.14c94fe1.png";